// src/routes/useHydratedAccess.ts
import * as React from "react";
import { useLoginStore } from "../../store/useLoginStore";

export function useHydratedAccess() {
  const [ready, setReady] = React.useState(
    useLoginStore.persist?.hasHydrated?.() ?? true
  );

  React.useEffect(() => {
    const unsub = useLoginStore.persist?.onFinishHydration?.(() => setReady(true));
    if (useLoginStore.persist?.hasHydrated?.()) setReady(true);
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    return () => { unsub && unsub(); };
  }, []);

  return ready;
}